import React from "react";
import { Link } from "react-router-dom";

export default function Logo({ size = "md" }) {
  const text = size === "sm" ? "text-lg" : "text-xl";
  return (
    <Link to="/" data-testid="nav-logo" className="group flex items-center gap-2">
      <div className="relative h-8 w-8">
        <div className="absolute inset-0 rounded-full bg-wine ring-1 ring-blush/40 transition group-hover:-translate-x-0.5" />
        <div className="absolute inset-0 translate-x-2 rounded-full bg-blush transition group-hover:translate-x-1" />
        <div className="absolute inset-[9px] translate-x-1 rounded-full bg-rose" />
      </div>
      <div className={`font-display ${text} font-extrabold lowercase tracking-tight`}>
        <span className="text-blush">after</span><span className="text-rose">hours</span><span className="text-cream">.</span>
      </div>
    </Link>
  );
}
